export default "__VITE_ASSET__BwjCEiVn__"